import { useNavigate } from 'react-router-dom';
import { Box, Grow } from '@mui/material';
import { AppDispatch, RootState } from '../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import IMTitle from '../../components/typography/IMText';
import IMText from '../../components/typography/IMTitle';
import CountryRect from './components/CountryRect';
import IMQuestionsProgressBar from '../../components/common/IMQuestionsProgressBar';
import IMBottomButtonsContainer from '../../components/common/buttons/IMBottomButtonsContainer';
import IMButton from '../../components/common/buttons/IMButton';
import IMConfirmDialog from '../../components/common/dialogs/IMConfirmDialog';
import IMPage from '../../components/common/layout/IMPage';
import { activateNextCard, awaitWithLoading, removeCountry, selectCountries, selectSectionNumber, selectTotalSectionsCount } from '../../store/idealCountrySlice';

const SubResult = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const [countryToDelete, setCountryToDelete] = useState<any>(null);

	const card = useSelector((state: RootState) => state.idealCountry.nextCard);
	const countries = useSelector(selectCountries);
	const sectionNumber = useSelector(selectSectionNumber);
	const totalSectionsCount = useSelector(selectTotalSectionsCount);
	const curCardIndex = useSelector((state: RootState) => state.idealCountry.currentCardIndex);

	useEffect(() => {
		if (!card) {
			navigate('/start');
		}
	}, [navigate]);

	const onContinueClick = async () => {
		await dispatch(awaitWithLoading({ timeout: 700 }))
		dispatch(activateNextCard());
		navigate('/questions');
	};

	const onDeleteCountryClick = async (country: any) => {
		setCountryToDelete(country);
	}

	return (
		<IMPage sx={{ backgroundColor: 'unset' }}>
			<IMQuestionsProgressBar questionIndex={curCardIndex + 1} totalStages={totalSectionsCount}></IMQuestionsProgressBar>
			<Box
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						background: '#ECF8ED',
						borderRadius: '12px',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						flexShrink: 0,
						flex: 1,
						margin: '0 12px 12px 12px'
					}}
				>
					<IMTitle weight="700" size="22px" color="#212B36" textAlign="center">
						Лучшие иммиграционные возможности
					</IMTitle>
					<IMText
						weight="500"
						size="16px"
						color="#212B36"
						textAlign="center"
						props={{ marginTop: '10px' }}
					>
						Секция {sectionNumber + 1}/{totalSectionsCount}
					</IMText>
				</Box>
				<Box
					sx={{
						display: 'flex',
						gap: '8px',
						flexWrap: 'wrap',
						overflow: 'auto',
						margin: '0 12px 12px 12px',
						padding: '0 0 78px 0',
						flex: 3,
					}}
				>
					{countries.map((c, index) => (
						<Grow
							in={true}
							style={{ transitionDelay: `${index * 50}ms` }}
							timeout={400}
							key={c.id}
						>
							<Box sx={{
								width: 'calc(50% - 6px)',
								height: '40vw',
								flexShrink: 0,
								display: 'flex',
							}}>
								<CountryRect
									country={c}
									onDeleteClick={() => onDeleteCountryClick(c)}
									sx={{
										flex: 1
									}}
								></CountryRect>
							</Box>
						</Grow>
					))}
				</Box>
			</Box>
			<IMBottomButtonsContainer>
				<IMButton onClick={onContinueClick}>
					Продолжить
				</IMButton>
			</IMBottomButtonsContainer>

			<IMConfirmDialog
				open={!!countryToDelete}
				onClose={() => setCountryToDelete(null)}
				onConfirm={() => {
					if (countryToDelete) {
						dispatch(removeCountry(countryToDelete));
					}
					setCountryToDelete(null);
				}}
				title="Вы уверены что хотите удалить эту страну из списка рекомендаций?"
			/>
		</IMPage>
	);
};

export default SubResult;
